var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrihowBig = function SvgIconTrihowBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#239AE7",
    d: "M4.5 21.5v-4.635q2.285-1.586 3.23-3.216.943-1.63 1.309-2.899H6.433v-1.5h2.452a4.2 4.2 0 0 1-.738-1.194 3.7 3.7 0 0 1-.272-1.431q0-1.719 1.204-2.922T12.002 2.5t2.921 1.203 1.202 2.922q0 .767-.272 1.43a4.2 4.2 0 0 1-.738 1.195h2.462v1.5h-2.596q.355 1.26 1.294 2.894.938 1.635 3.225 3.221V21.5zM6 20h12v-2.327q-2.108-1.666-3.123-3.448t-1.452-3.475h-2.84q-.437 1.692-1.457 3.475T6 17.673zm6.004-10.75q1.104 0 1.862-.761.759-.762.759-1.864t-.76-1.864q-.76-.76-1.862-.761-1.1 0-1.864.761-.764.762-.764 1.864t.762 1.864q.762.76 1.867.761"
  })));
};
export default SvgIconTrihowBig;